import {Helmet} from 'react-helmet-async'
import {useIntl} from 'react-intl'

/**
 * Default site title and meta description. Used when no page sets its own Helmet.
 * Updates with the active locale.
 */
export const DefaultMeta = () => {
  const intl = useIntl()
  const title = intl.formatMessage({id: 'META.SITE_TITLE'})
  const description = intl.formatMessage({id: 'META.SITE_DESC'})
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
    </Helmet>
  )
}
